export default __webpack_public_path__ + "static/media/downarrow.366615b7.svg";